let isInited = false;

export function initLazySizes() {
  if (isInited) {
    return;
  }

  require('lazysizes');

  const listener = (event: CustomEvent) => {
    const element = event.target as HTMLElement;
    const bg = element.getAttribute('data-bg');
    if (bg) {
      element.style.backgroundImage = `url("${bg}")`;
    }
  };

  document.addEventListener('lazybeforeunveil', listener);

  isInited = true;
}
